import { render, staticRenderFns } from "./ImagePoint.vue?vue&type=template&id=327a4970&scoped=true"
import script from "./ImagePoint.vue?vue&type=script&lang=js"
export * from "./ImagePoint.vue?vue&type=script&lang=js"
import style0 from "./ImagePoint.vue?vue&type=style&index=0&id=327a4970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a4970",
  null
  
)

export default component.exports